var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9552 73.0672L23.397 55.8051C23.0079 55.4225 22.3839 55.4225 21.9948 55.8051L17.2253 60.4941C16.8268 60.886 16.8268 61.5285 17.2253 61.9203L40.2542 84.5608C40.6433 84.9433 41.2672 84.9433 41.6563 84.5608L92.7747 34.3045C93.1732 33.9127 93.1732 33.2702 92.7747 32.8783L88.0052 28.1892C87.6161 27.8067 86.9921 27.8067 86.603 28.1892L40.9552 73.0672Z",
    fill: "#019A34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.3b1525bc.svg";
export { ForwardRef as ReactComponent };